/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

/* eslint-disable import/prefer-default-export */

import { Sentiment, InsightViewOption } from '../../../../enums'
import { SentimentWidgetsType } from '../types'
import { DashboardWidget } from '../../../../features/widget/types'
import { InsightCount } from '../../../../schemas/action/InsightCountSchema'
import { InsightData } from '../../../../schemas/action/InsightDataSchema'

export const getFilteredInsightDataSet = (
  widgetData: DashboardWidget<InsightCount>,
  widgetSetting: SentimentWidgetsType
): InsightData[] => {
  // NI-2615: same family of bug as the SentimentDrivers WordCloud (PR #83) —
  // Prospero may omit `insights` (or return an empty dataset) for a (topic x
  // category) pair, and the unguarded `insights![0].dataset![0].set` chain
  // throws `Cannot read properties of undefined (reading '0')` through to the
  // outer ErrorBoundary. Optional-chain to [] so the upstream
  // `SentimentEmptyResultGuard` renders the friendly "no data" state instead.
  const entries = widgetData?.data?.[0]?.results?.[0]?.data?.insights?.[0]?.dataset?.[0]?.set ?? []
  return entries.filter(
    (entry) =>
      widgetSetting.viewOption === InsightViewOption.POSITIVE_NEGATIVE_NEUTRAL ||
      entry.name !== Sentiment.NEUTRAL
  )
}
